import { useRouter } from 'next/router';

import Head from 'next/head';
import Layout from 'components/Layout';

import ComponentsMap from 'templates/PlansTemplate/components';
import { ScholarShipContextProvider } from 'providers/ScholarshipProvider';
import { TestingProvider } from 'providers/TestingAndExperimentingProvider';
import { PlansTabs } from 'mocks/menuNav';

export default function PlansTemplate(props) {
  const router = useRouter();
  const cp = !!router.query.cp;
  const openWidget = !!router.query.open;
  const plans = props?.plans || [];
  const hasPlans = plans && plans.length > 0;
  const isScholarShip = hasPlans && plans.some((plan) => !!plan.code);

  const title =
    props?.pageTitle || 'Fluencypass - Assine seu plano de fluência';
  const description =
    props?.pageDescription ||
    'O ciclo completo da fluência: Aulas 24h, conversação, aula particular e intercâmbio no final.';

  return (
    <Layout
      maxWidth="lg"
      footerProps={{
        useStyles: false,
        styleProps: { pt: 4, pb: props?.addFooterPb ? 12 : 0 },
      }}
      tabs={PlansTabs}
    >
      <Head>
        <title>{title}</title>
        <meta content={title} key="title" property="og:title" />
        <meta
          content={description}
          key="og:description"
          property="og:description"
        />
        <meta content={description} key="description" name="description" />
      </Head>

      <TestingProvider toBeTested={props?.toBeTested}>
        <ScholarShipContextProvider isScholarship={isScholarShip}>
          <ComponentsMap cp={cp} openWidget={openWidget} {...props} />
        </ScholarShipContextProvider>
      </TestingProvider>
    </Layout>
  );
}
